export default function AdSlot({ slot }) {
  return null;
}
